import { InMemoryCache } from '@apollo/client/cache'

export const tunistryCache = new InMemoryCache({
    typePolicies: {
        RoomUpdateData: {
            merge(existing, incoming) {
                // RoomUpdateData doesn't have an ID, so we always replace with incoming data
                return incoming
            }
        },
        Query: {
            fields: {
                searchTracks: {
                    keyArgs: ["params"],
                    merge(existing = { tracks: [] }, incoming) {
                        // Eliminate dupes.  Since we're always checking the network we'll get repeats.
                        const newTracks = incoming.tracks.filter( track => !existing.tracks.find( e => e.__ref === track.__ref ) )
                        const merged = { cursor: incoming.cursor }
                        merged.tracks = [ ...existing.tracks, ...newTracks ]
                        return merged
                    }
                },
                history: {
                    keyArgs: ["roomId"],
                    merge(existing = { events: [] }, incoming) {
                        const merged = { cursor: incoming.cursor }
                        // We might be getting old events from a history call or new events from the room subscription,
                        // so we need to check whether what we just received belongs at the beginning or the end of
                        // the history.
                        const latestIncomingId = incoming.events[0]?.__ref.split(':')[1]
                        const latestExistingId = existing.events[0]?.__ref.split(':')[1]

                        let combined
                        if (latestIncomingId > latestExistingId) {
                            combined = [ ...incoming.events, ...existing.events ]
                        } else {
                            combined = [ ...existing.events, ...incoming.events ]
                        }

                        // Deduplicate events by __ref to prevent duplicate keys in React
                        const seen = new Set()
                        merged.events = combined.filter(event => {
                            if (seen.has(event.__ref)) {
                                return false
                            }
                            seen.add(event.__ref)
                            return true
                        })

                        return merged
                    }
                },
                publicRooms: {
                    keyArgs: false,
                    merge(existing = { rooms: [] }, incoming) {
                        const merged = { cursor: incoming.cursor }
                        const newRooms = incoming.rooms?.filter(r => !existing.rooms?.find(e => e.__ref === r.__ref)) ?? []
                        merged.rooms = [ ...(existing.rooms ?? []), ...newRooms ]
                        return merged
                    }
                }
            }
        }
    }
})

export default tunistryCache
